import { useState } from "react";
import { BasicProps } from "./ComponentsInterface";
import { faCaretRight, faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const LAccordion = ({ title, isFirst, isLast, children }: AccordionProps): JSX.Element => {
    const [expand, setExpand] = useState(false);

    const accordionStyle = {
        borderTopLeftRadius: "0",
        borderTopRightRadius: "0",
        borderBottomLeftRadius: "0",
        borderBottomRightRadius: "0",
        borderBottom: "solid 1px lightgray"
    };

    if (isFirst) {
        accordionStyle.borderTopLeftRadius = "6px";
        accordionStyle.borderTopRightRadius = "6px";
    }

    if (isLast) {
        accordionStyle.borderBottomLeftRadius = "6px";
        accordionStyle.borderBottomRightRadius = "6px";
        accordionStyle.borderBottom = expand ? accordionStyle.borderBottom : "0";
    }

    return (
        <div className="box is-shadowless py-4 px-0 mb-0" style={accordionStyle}>
            <div className="columns mx-4 my-0 is-align-items-center" onClick={() => setExpand(!expand)}>
                <div className="column">
                    <div className="has-text-right has-text-link">
                        {!expand && <FontAwesomeIcon icon={faCaretRight} size="sm" />}
                        {expand && <FontAwesomeIcon icon={faCaretDown} size="sm" />}
                    </div>
                </div>
                <div className="column is-full pl-0">
                    <h2 className="title is-6 has-text-ldark-gray extra-bold">{title}</h2>
                </div>
            </div>
            <div>{expand && children}</div>
        </div>
    );
};

interface AccordionProps extends BasicProps {
    title: string | JSX.Element;
    isFirst?: boolean;
    isLast?: boolean;
}
